import axios from 'axios'
import Swal from 'sweetalert2'

export class Rollen{
    static async add(email, rollenID){
        try {
            const response = await axios.post("https://feuerwehr-server.org:5000/createRolleZuBenutzer", {
                email: email,
                rollenID: rollenID
            });
            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    static async get(email){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/rollen`, {
                    params: { email: email }
                }
            );

            // Hier kannst du die Daten weiterverarbeiten oder in der Komponente verwenden
            localStorage.setItem('Rollen', JSON.stringify(response.data));
            return response.data;
        } catch (err) {
            console.error(err);
            let local = this.getLocal();
            if(local == false || local == "" || local.length == 0){
                return false;
            } else{
                return local;
            }
        }
    }

    static getLocal(){
        return JSON.parse(localStorage.getItem('Rollen'));
    }

    static async save(email, rollenIDs){
        try{
            console.log(email);
            console.log(rollenIDs);
            await axios.post(
                "https://feuerwehr-server.org:5000/saveRollen",
                {
                email: email,
                rollenIDs: rollenIDs
                }
            );
            Swal.fire("Gespeichert", "Die Rollen wurden aktualisiert", "success");
        } catch(err){
            Swal.fire('Error', 'Rollen konnten nicht aktualisiert werden', 'error')
        }
    }
}
